"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mutation_types_1 = require("./mutation-types");
exports.default = {
    [mutation_types_1.MutationTypes.SET_LOADING](state, value) {
        state.loading = value;
    },
};
//# sourceMappingURL=mutations.js.map